import Vue from 'vue'
import Vuetify from 'vuetify'
import colours from 'vuetify/es5/util/colors';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  theme:
  {
    primary: '#2a6171',
    secondary: '#75cac3',
    accent: '#f34573',

    error: colours.red.base,
    warning: colours.amber.base,
    // info: colours.cyan.base,
    info: '#75cac3',
    success: colours.lightGreen.base
  },
  iconfont: 'mdi',
});

export default new Vuetify({
  theme:
  {
    themes: {
      light:
      {
        primary: '#2a6171',
        secondary: '#75cac3',
        accent: '#f34573',

        error: colours.red.base,
        warning: colours.amber.base,
        // info: colours.cyan.base,
        info: '#75cac3',
        success: colours.lightGreen.base
      },
      dark:
      {
        primary: '#2a6171',
        secondary: '#75cac3',
        accent: '#f34573',
    
        error: colours.red.base,
        warning: colours.amber.base,
        // info: colours.cyan.base,
        info: '#75cac3',
        success: colours.lightGreen.base
      },
    }
  }
});
